import gsap from "gsap";
import { AudioService } from 'src/app/services/audio/audio.service';
import { Component, NgZone, OnInit } from '@angular/core';
import { Navigator } from '../../menu/navigator';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { PurchaseService } from "src/app/services/purchase/purchase.service";
import { distinctUntilChanged, filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { EventsService } from "src/app/services/event/event.service";
import { BonusService } from "src/app/services/bonus/bonus.service";

@Component({
  selector: 'app-navbar-shop',
  templateUrl: './navbar-shop.component.html',
  styleUrls: ['./navbar-shop.component.scss'],
})
export class NavbarShopComponent implements OnInit {

  public customer: CustomerModel;
  protected tween: any;
  protected chipCount: number = 0;
  protected shopBannerMarketingText: string = 'SPECIAL OFFER';
  protected isLoggedIn: boolean = false;
  isPremAvailable: boolean = false;
  private destroy$ = new Subject<void>();
  customerId: number;
  bonusPurchases: any;
  bonusOffers: any[] = [];
  protected showSpecialOffers: boolean = false

  constructor(
    private readonly accountBalanceService: AccountBalanceService,
    private readonly navigator: Navigator,
    private audioService: AudioService,
    private bonusService: BonusService,
    private userSessionService: UserSessionService,
    private purchase: PurchaseService,
    private zone: NgZone,
    private eventsService:EventsService
  ) { }

  ngOnInit() {
    this.isUserLoggedIn();
    this.eventsService.subscribe("event:call:getpremium", () => {
      this.getAvailablePremiumBonus();
    });
    this.eventsService.subscribe("event:call:getpremium-red-dot", () => {
      this.getAvailablePremiumBonus();
    })
    
    // check, if there are nay special offers avalible
    setTimeout(() => {
      try{
          this.bonusService.callGetBonusOffers().subscribe((response) => {
            this.bonusOffers = response.payload?.reverse();
            if (this.bonusOffers.length > 0) {
              this.showSpecialOffers = true
            } else {
              this.showSpecialOffers = false
            }
          })
        }catch(e){
          console.log("Error while getting bonus offers in navbar",e)
        }
    }, 1000);
    
  }

  offerCounter = 0
  openOffers() {
    this.bonusService.callGetBonusOffers().subscribe((response) => {
      this.bonusOffers = response.payload?.reverse();
      if (this.bonusOffers.length > 0) {
        this.showNotifications(this.offerCounter);
      } else {
        this.showMessage();
      }
    })
  }

  showMessage() {
		const popoverComp = 'PopoverAlertComponent';

		let data: any = {
			content: "You don't have any available promotions right now. Please check back later!",
		};

		return this.navigator.openPopover(popoverComp, data);
  }

  showNotifications(i) {
    let e = this.bonusOffers[i];
    this.showNotification(e);

  }

  showNotification(e) {
    e.onCloseFunc = this.nextNotification;
    this.navigator.openPopover(
      'PopoverMarketingComponent',
      e,
      'standard-popover marketing-notification',
      true,
      true,
      true
    );

    this.eventsService.publish("event:marketingpopup:active");

  }
  showNextNotification(){
    this.offerCounter++;
    if (this.offerCounter < this.bonusOffers.length) {
      this.showNotifications(this.offerCounter);
      this.eventsService.publish("event:notifications:forceStart");
    }else{
        this.offerCounter = 0;
      this.eventsService.publish("event:marketingpopup:inactive");
    }
  }

  nextNotification = (emmiter = null) => {
    this.eventsService.publish("event:marketingpopup:inactive");
    if (emmiter === 'closeButton') {
      this.showNextNotification();
    }
  };

  protected isUserLoggedIn() {

    // this.userSessionService.getCustomer().subscribe((customer) => {
    //   if (customer) {
    //     this.customer = customer;
    //     this.isLoggedIn = true;

    //     this.accountBalanceService.getBalance().subscribe((val) => {
    //       // console.log(`updating balance to ${val}`, val);

    //       // store the newBalance from val.PLAY.availableBalance
    //       let newBalance = val != null && val.PLAY != null ? val.PLAY.availableBalance : 0;

    //       // tween the chipCount to the newBalance
    //       this.updateBalance(newBalance);
    //     });

    //   } else {
    //     this.isLoggedIn = false;
    //   }
    // });

    this.userSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription
        .pipe(
          takeUntil(this.destroy$),
          filter((customer) => !!customer),
          map((customer) => customer.customerId),
          distinctUntilChanged()
        )
        .subscribe((customerId) => {
          if (customerId && localStorage.getItem('userSession.sessionToken') !== null) {
            this.isLoggedIn = true;
            this.customerId = customerId;
            this.getAvailablePremiumBonus();
            this.accountBalanceService.getBalance().subscribe((val) => {
              // console.log(`updating balance to ${val}`, val);

              // store the newBalance from val.PLAY.availableBalance
              let newBalance = val != null && val.PLAY != null ? val.PLAY.availableBalance : 0;

              // tween the chipCount to the newBalance
              this.updateBalance(newBalance);
            });
          }else {
            this.isLoggedIn = false;
          }
        });
    });
  }


  protected updateBalance(newBalance: number) {
    if (this.tween != null)
      this.tween.kill();

    let durationSeconds = 1;

    // different easing options https://gsap.com/docs/v3/Eases/
    // let ease = "circ.out";
    let ease = "power4.out"

    this.tween = gsap.to(this, {
      duration: durationSeconds, chipCount: newBalance, ease: ease,
      onUpdate: () => {
        // call the zone.run to force render the shadow dom element
        this.zone.run(() => {
          this.chipCount = Math.floor(this.chipCount)

          // if the chipCount is greater than 100,000,000,000 then adjust font size
          let chipCountElement: any = document.querySelector(".chip-count");
          if (this.chipCount >= 1000000000000) {
            chipCountElement.style.fontSize = "10px";
            chipCountElement.style.letterSpacing = "0px";
          }
          else if (this.chipCount >= 1000000000) {
            chipCountElement.style.fontSize = "12px";
            chipCountElement.style.letterSpacing = "0.5px";
          }
          else {
            chipCountElement.style.fontSize = "";
            chipCountElement.style.letterSpacing = "";
          }
        })
      }
    })
  }

  getAvailablePremiumBonus() {
    let customerBonus = [];
    this.purchase.getCustomerPremiumPurchases().subscribe((premiumCustomerPerchasRes) => {
      customerBonus = premiumCustomerPerchasRes.result ? premiumCustomerPerchasRes.payload : [];
        if (premiumCustomerPerchasRes.payload.length) {
          this.bonusPurchases = this.formatPremiumBonus(customerBonus, premiumCustomerPerchasRes.payload);
        }
    });
  }

  protected orderedValues = (item) => {
    const isActiveBonus = (item && item.premiumChipsDefinition);
    const currentDay = isActiveBonus ? this.checkCurrentDate(item.collects) : null;
    return {
      ...item,
      totalDays: isActiveBonus ? item.premiumChipsDefinition.cycles : item.cycles,
      isActiveBonus: isActiveBonus,
      totalOf: !isActiveBonus ? item.chipsAmount * item.cycles : 0,
      priceCode: isActiveBonus ? item.premiumChipsDefinition.priceCode : item.priceCode,
      startTime: isActiveBonus ? (currentDay && currentDay.startTime) ? currentDay.startTime : "" : "",
      currentDay: isActiveBonus ? (currentDay && currentDay.day) ? currentDay.day : "" : "",
      endTime: isActiveBonus ? (currentDay && currentDay.endTime) ? currentDay.endTime : "" : "",
    };
  }


  formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const formattedDate = date.toISOString();
    return formattedDate;
  }

  protected formatPremiumBonus(customerBonus, aviableBonus) {
    customerBonus = customerBonus.filter(item => item.collects.some(collect => collect.status === "PENDING"));
    const payload = aviableBonus.map((bonusObj) => {
      const customerBonusItem = customerBonus.find((purchaseObj: any) => purchaseObj.premiumChipsDefinition.priceCode === bonusObj.priceCode);
      return customerBonusItem ? customerBonusItem : bonusObj;
    }).map(this.orderedValues);
    return payload;
  }


  checkCurrentDate(collects) {
    const currentDate = this.formatTimestamp(Date.now());
    let currentDay;
    collects.sort((a, b) => a.day - b.day);
    for (let i = 0; i < collects.length; i++) {
      const collect = collects[i];
      const startDate = this.formatTimestamp(collect.startTime);
      const endDate = this.formatTimestamp(collect.endTime);
      if ((startDate <= endDate && currentDate <= endDate) &&
        (collect.status === "PENDING")) {
        this.isPremAvailable = true;
        currentDay = { ...collect };
        break;
      } else {
        this.isPremAvailable = false;
      }

    }
    return currentDay;

  }

  protected openShop(): any {
    this.audioService.playSound("ShopOpen")
    return this.navigator.navigateTo('ShopPageComponent', { customModalClass: 'custom-shop-model-class-transparent', backdropDismiss: true });
  }

}
